import React from "react";
import ComicBase from "../ComicBase";

export default function ComicNaruto() {
  return (
    <ComicBase
      titulo="TOUCHUUKASOU parte 4"
      portada="https://fullcomics18.org/img6/touchuukasou4-1.jpg"
    paginas={[
  "https://fullcomics18.org/img6/touchuukasou4-1.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-2.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-3.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-4.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-5.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-6.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-7.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-8.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-9.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-10.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-11.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-12.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-13.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-14.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-15.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-16.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-17.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-18.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-19.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-20.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-21.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-22.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-23.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-24.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-25.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-26.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-27.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-28.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-29.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-30.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-31.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-32.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-33.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-34.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-35.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-36.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-37.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-38.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-39.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-40.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-41.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-42.jpg",
  "https://fullcomics18.org/img6/touchuukasou4-43.jpg"
]}
      sugeridos={[]}


      info={{
         grupo: "shoot the moon",
    tipo: "	doujinshi",
    idioma: "Español",
    serie: "Original",
    personajes: [" "],
etiquetas: ["Ahegao", "Beauty Mark", "Big Areolae", "Big Ass", "Big Breasts", "Big Nipples", "Big Penis", "Blindfold", "Blowjob", "Bondage", "Defloration", "Digital Fingering", "Freckles", "Gag", "Huge Breasts", "Lingerie", "Mind Break", "Moral Degeneration", "Multi-work Series", "Nakadashi", "Netorare", "Sex Toys", "Shaved Head", "Shibari", "Sole Male", "Spanking", "Sweating", "X-Ray"],
    artistas: "Fuetakishi",
      }}
    />
  );
}

export const infoManga = {
  titulo: "TOUCHUUKASOU parte 4",
  portada: "https://fullcomics18.org/img6/touchuukasou4-1.jpg",
  reverso: "https://fullcomics18.org/img6/touchuukasou4-22.jpg",
   fecha:"2026-05-16",


  info: {
    grupo: "shoot the moon",
    tipo: "	doujinshi",
    idioma: "Español",
    serie: "Original",
    personajes: [" "],
etiquetas: ["Ahegao", "Beauty Mark", "Big Areolae", "Big Ass", "Big Breasts", "Big Nipples", "Big Penis", "Blindfold", "Blowjob", "Bondage", "Defloration", "Digital Fingering", "Freckles", "Gag", "Huge Breasts", "Lingerie", "Mind Break", "Moral Degeneration", "Multi-work Series", "Nakadashi", "Netorare", "Sex Toys", "Shaved Head", "Shibari", "Sole Male", "Spanking", "Sweating", "X-Ray"],
    artistas: "Fuetakishi",
  },
};
